// @flow
import React from 'react';
import classnames from 'classnames';

import { ChoiceList } from 'Components/frameworks/choice-list/ChoiceList.jsx';
import { FacetLabel } from './FacetLabel.jsx';

type Props = {
  title: string,
  name: string,
  facets: Array<SearchFacetList>,
  activeFacets: *,
  className?: string,
  listClassName?: string,
  onChange: (name: string, checked: boolean, value: string | boolean) => void,
};

const defaultProps = {
  listClassName: '',
};

const getChoices = ({ facets, activeFacets }: Props) => {
  // Safeguard: API can return facets with null names, that must be ignored.
  return facets.filter(({ label }) => !!label).map(({ label, count, value }) => ({
    label: <FacetLabel count={count}>{label}</FacetLabel>,
    value,
    isSelected: activeFacets && activeFacets[value],
  }));
};

export const FacetList = (props: Props) => (
  <ChoiceList
    choices={getChoices(props)}
    className={classnames('FacetList', props.className)}
    listClassName={props.listClassName}
    name={props.name}
    onChange={props.onChange}
    title={props.title}
  />
);

FacetList.defaultProps = defaultProps;
